import { Button } from '@opendoor/bricks-next';

import type { IBNComponentThemeConfig } from '../styles/ComponentTheme';
import { FooterForegroundBox } from './Footer';

const FooterHelpCenter = ({
  theme,
  helpCenterLink,
}: {
  theme: IBNComponentThemeConfig;
  helpCenterLink?: string;
}) => {
  return (
    <FooterForegroundBox theme={theme} title="Still have questions?">
      <Button
        href={helpCenterLink}
        aria-label="Opendoor Help Center button"
        analyticsName="cosmos-landing-page-v2-footer-help-center"
        variant="secondaryInverse"
        size="xsmall"
        label="Visit the Help Center"
        maxWidth="$450x"
        hoverStyle={{ backgroundColor: '$backgroundInverseStateHoverPrimary' }}
      />
    </FooterForegroundBox>
  );
};

export default FooterHelpCenter;
